<template>
	<div class="con">
		<div class="title">
			<div class="titles">活动名称：{{title}}</div>
		</div>
		<div class="nav">
			<div class="navs" :class="[dataForm.type==2?'navselect':'']" @click="dataForm.type=2">组织</div>
			<div class="navs" :class="[dataForm.type==1?'navselect':'']" @click="dataForm.type=1">个人</div>
		</div>
		<div class="cons">
			<div class="cons01">
				<div class="co01">报名信息</div>
				<div class="co02"></div>
				<div class="co03">请填写报名信息</div>
			</div>
			<div class="cons02">
				<el-form :model="dataForm" ref="dataForm" :inline="false" :rules="rules">
					<el-form-item label="名称" :prop="dataForm.type==2?'title':''" v-if="dataForm.type==2">
						<el-input placeholder="请输入" v-model="dataForm.title"></el-input>
					</el-form-item>
					<el-form-item style="margin-top: 22px;" :label="dataForm.type==1?'姓名':'联系人姓名'">
						<el-input placeholder="请输入" v-model="dataForm.name"></el-input>
					</el-form-item>
					<!--联系人的信息-->
					<el-row style="display: flex;margin-top: 22px;">
						<el-col :span="7">
							<el-form-item :label="dataForm.type==1?'性别':'联系人性别'" class="buxu">
								<el-select style="width: 100%;" v-model="dataForm.sex" placeholder="请选择">
								    <el-option
								      v-for="item in [{value:'男'},{value:'女'}]"
								      :key="item.value"
								      :label="item.value"
								      :value="item.value">
								    </el-option>
								  </el-select>
							</el-form-item>
						</el-col>
						<el-col :span="7" style="margin-left: auto;">
							<el-form-item :label="dataForm.type==1?'电话':'联系人电话'" prop="phone">
								<el-input type="number" placeholder="请输入" v-model="dataForm.phone"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="7" style="margin-left: auto;" v-if="dataForm.type==2">
							<el-form-item label="人数" :prop="dataForm.type==2?'num':''">
								<el-input type="number" placeholder="请输入" v-model="dataForm.num"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					
					<!--联系人的信息-->
					<el-form-item label="" style="margin-top: 20px;">
						<el-button style="width: 100px;background: #f6f8f9;border-radius: 40px;" @click="quxiao">取消</el-button>
						<el-button style="width: 100px;border-radius: 40px;" type="primary" @click="save">提交</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
	import { user_hdbaoming_save } from "@/api/news"
	export default {
		components:{
			
		},
		name:"hdbaoming",
		data(){
			return{
				dataForm:{
					type:2,//1个人 组织
					newsid:'',//活动id
					title:'',//名称
					name:'',
					sex:'',
					phone:'',
					num:''
				},
				rules:{
					title:[{ required: true, message: '不能为空', trigger: 'blur' }],
					name:[{ required: true, message: '不能为空', trigger: 'blur' }],
					phone:[{ required: true, message: '不能为空', trigger: 'blur' }],
					num:[{ required: true, message: '不能为空', trigger: 'blur' }],
				},
				title:'',//活动名称
			}
		},
		watch:{

		},
		mounted(){
			this.dataForm.newsid = this.$route.query.newsid
			this.title = this.$route.query.title
		},
		methods:{
			async save(){
				let that = this;
				that.$refs['dataForm'].validate((valid) => {
					if (valid) {
						let form = {};
						if(that.dataForm.type==1){
							form = {
								newsid:that.dataForm.newsid,
								name:that.dataForm.name,
								sex:that.dataForm.sex,
								phone:that.dataForm.phone,
                                type:1
							}
						}
						if(that.dataForm.type==2){
							form = {
								newsid:that.dataForm.newsid,
								title:that.dataForm.title,
								name:that.dataForm.name,
								sex:that.dataForm.sex,
								phone:that.dataForm.phone,
								num:that.dataForm.num,
								type:2
							}
						}
						console.log("请求的参数",form);
						const loading = this.$loading({
						    lock: true,
						    text: '提交中',
						    spinner: 'el-icon-loading',
						    background: 'rgba(0, 0, 0, 0.7)'
						  });
						user_hdbaoming_save(form).then(res=>{
							loading.close();
							that.$message.success("报名成功");
							//此时携带orderid跳转到订单页面
							console.log(res.data.orderid);
							this.$router.push({
								path:"/neirong",
								query:{
									orderid:res.data.orderid,
									neirongtype:4
								}
							})
						}).catch(()=>{
							loading.close();
						})
					}else{
						
					}
				})
			},
			dianjis(type){
				this.imgtype = type
				//环境图标
				this.$refs.upload1.handleUpload();
			},
			quxiao(){
				this.$router.push({
					path:"/newsdetail",
					query:{
						id:this.dataForm.newsid
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.shangchuan{
		margin-left: 10px;
	}
	/deep/ .buxu{
		margin-bottom: 0px!important;
	}
	/deep/ .el-input__inner{
		background: #f6f8f9!important;
	}
	/deep/ .el-form-item__label:before {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
		display: none;
	}
	/deep/ .el-form-item__label:after {
		content: '*';
		color: #F56C6C;
		margin-left: 4px;
	}
	/deep/ .buxu .el-form-item__label:after {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
		display: none;
	}
	.imgurl{
		width: 100px;
		height: 100px;
		border: 1px solid #dfdfdf;
		border-radius: 10px;
		img{
			width: 100%;
			height: 100%;
			border-radius: 10px;
		}
	}
	.con{
		.cons{
			width: 100%;
			display: flex;
			padding-top: 30px;
			padding-bottom: 30px;
			.cons01{
				width: 30%;
				.co01{
					color: #333;
					font-size: 18px;
				}
				.co02{
					width: 30px;
					height: 2px;
					background: #00a9f2;
					margin-top: 5px;
				}
				.co03{
					color: #666;
					font-size: 14px;
					margin-top: 15px;
				}
			}
			.cons02{
				width: 65%;
				margin-left: auto;
			}
		}
		.navselect{
			background: #00a9f2;
			color: #fff!important;
		}
		.nav{
			width: 100%;
			height: 80px;
			border-bottom: 1px solid #dfdfdf;
			display: flex;
			align-items: center;
			cursor: pointer;
			.navs{
				width: 100px;
				height: 40px;
				border-radius: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #333;
				font-size: 16px;
			}
		}
		.title{
			width: 100%;
			height: 50px;
			border-bottom: 1px solid #dfdfdf;
			position: relative;
			.titles{
				height: 30px;
				color: #333;
				font-size: 16px;
				position: absolute;
				bottom: 0px;
				right: 30px;
			}
		}
		width: 1200px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/views/news/baoming.vue